import { render, staticRenderFns } from "./AccountCore.vue?vue&type=template&id=37561f04&"
import script from "./AccountCore.vue?vue&type=script&lang=js&"
export * from "./AccountCore.vue?vue&type=script&lang=js&"
import style0 from "./AccountCore.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports